import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import { isBetween, YYYYMMDDFormat } from "app/_helpers/dateHelper";
import { employeeTrainingDesignationList } from "app/_pages/UserManagement/Employee/Constant";

export const initialTrainingAssignersForm = {
  siteId: "",
  workAreaId: "",
  categoryId: "",
  trainingId: "",
  duration: "",
  initialDate: "",
  dueDate: "",
};

export const initialAssigner = {
  category: "",
  name: "",
  email: "",
  initialDate: "",
  dueDate: "",
  userId: "",
};

export const getStatusClass = (status) => {
  switch (status) {
    case "Verified":
      return "success";
    case "Completed":
      return "pending";
    case "In Progress":
      return "orange";
    case "Expired":
      return "expired";
    default:
      return "notstarted";
  }
};

export const getOverallStatus = (sessions) =>
  sessions.filter((s) => s.status === "Not Started").length === sessions.length
    ? "Assigned"
    : sessions.filter((s) => s.status === "Completed").length === sessions.length
    ? "Completed"
    : "In Progress";

export const TRAINING_TYPE = {
  basicTraining: "basicTraining",
  refreshTraining: "refreshTraining",
  newBasicTraining: "newBasicTraining",
  other: "other",
};

export const tabType = {
  2: "basicTraining",
  3: "newBasicTraining",
  4: "refreshTraining",
  5: "other",
  6: "batchesDetails",
};

export const TRAINING_TYPE_VIEW = {
  basicTraining: "Basic Training",
  refreshTraining: "Refresh  Training",
  newBasicTraining: "New Basic Training",
  other: "Other",
};

export const TRAINING_BATCHES_STATUS_VIEW = {
  scheduled: "Scheduled",
  completed: "Completed",
};

export const TRAINING_STATUS = {
  due: "due",
  scheduled: "scheduled",
  soReview: "soReview",
  mmReview: "mmReview",
  completed: "completed",
  overDue: "overDue",
  absent: "absent",
};

export const TRAINING_PROGRESS_CHECK = ["soReview", "mmReview", "scheduled"];

export const TRAINING_STATUS_VIEW = {
  due: "Due",
  scheduled: "Scheduled",
  soReview: "SO Review",
  mmReview: "MM Review",
  completed: "Completed",
  overDue: "Over Due",
  absent: "Absent",
};

export const TRAINING_SCHEDULE_STATUS_VIEW = {
  due: "Due",
  overDue: "Over Due",
  absent: "Due (Absent)",
};

export const YEAR_LIST = {
  year22: 2022,
  year23: 2023,
  year24: 2024,
  year25: 2025,
};

export const TRAINING_TYPE_OPTION = Object.keys(TRAINING_TYPE_VIEW).map((key) => ({
  label: TRAINING_TYPE_VIEW[key],
  id: key,
}));

export const TRAINEE_TYPE = {
  employee: "Employee",
  contractorPerson: "Contractor Person",
};

export const TRAINEE_TYPE_OPTION = Object.keys(TRAINEE_TYPE).map((key) => ({
  label: TRAINEE_TYPE[key],
  id: key,
}));

export const trainingStatusFilterFields = [
  {
    name: "traineeTypeView",
    title: "Staff Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys({ all: "All", ...TRAINEE_TYPE }).map((key) => ({
      label: { all: "All", ...TRAINEE_TYPE }[key],
      value: { all: "All", ...TRAINEE_TYPE }[key],
    })),
  },
  {
    name: "traineeId",
    title: "Name",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "traineeDesignation",
    title: "Designation",
    inputType: EFormFieldInputTypes.text,
    // inputType: EFormFieldInputTypes.searchableSelect,
    // options: employeeTrainingDesignationList,
  },
  {
    name: "trainingType",
    title: "Training Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(TRAINING_TYPE_VIEW).map((key) => ({
      label: TRAINING_TYPE_VIEW[key],
      value: key,
    })),
  },
  {
    name: "trainingCategory",
    title: "Skill Category",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "batchName",
    title: "Batch ID",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "siteId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "contractorId",
    title: "Contractor",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "trainingStatus",
    title: "Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(TRAINING_STATUS_VIEW).map((k) => ({
      label: TRAINING_STATUS_VIEW[k],
      value: k,
    })),
  },
];

export const trainingbatchFilterFields = [
  {
    name: "batchName",
    title: "Batch ID",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "centerName",
    title: "Centre Name",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "centerCode",
    title: "Centre Code",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "siteId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "contractorId",
    title: "Contractor",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "dateRange",
    title: "Date Range",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "trainingTypeView",
    title: "Training Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(TRAINING_TYPE_VIEW).map((key) => ({
      label: TRAINING_TYPE_VIEW[key],
      value: TRAINING_TYPE_VIEW[key],
    })),
  },
  {
    name: "trainingCategoryId",
    title: "Skill Category",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "batchStatusView",
    title: "Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(TRAINING_BATCHES_STATUS_VIEW).map((k) => ({
      label: TRAINING_BATCHES_STATUS_VIEW[k],
      value: TRAINING_BATCHES_STATUS_VIEW[k],
    })),
  },
];

export const trainingScheduleFilterFields = [
  {
    name: "traineeTypeView",
    title: "Staff Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys({ all: "All", ...TRAINEE_TYPE }).map((key) => ({
      label: { all: "All", ...TRAINEE_TYPE }[key],
      value: { all: "All", ...TRAINEE_TYPE }[key],
    })),
  },
  {
    name: "vtoId",
    title: "VTO",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  // {
  //   name: "trainingType",
  //   title: "Training Type",
  //   inputType: EFormFieldInputTypes.searchableSelect,
  //   options: Object.keys(TRAINING_TYPE_VIEW).map((key) => ({
  //     label: TRAINING_TYPE_VIEW[key],
  //     value: key,
  //   })),
  // },
  {
    name: "siteId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "contractorId",
    title: "Contractor",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "trainingStatusView",
    title: "Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(TRAINING_SCHEDULE_STATUS_VIEW).map((k) => ({
      label: TRAINING_SCHEDULE_STATUS_VIEW[k],
      value: TRAINING_SCHEDULE_STATUS_VIEW[k],
    })),
  },
  {
    name: "dueYear",
    title: "Due Year",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(YEAR_LIST).map((k) => ({
      label: YEAR_LIST[k],
      value: YEAR_LIST[k],
    })),
  },
  // {
  //   name: "trainingCategory",
  //   title: "Skill Category",
  //   inputType: EFormFieldInputTypes.searchableSelect,
  // },
  // {
  //   name: "trainingSubCategory",
  //   title: "Skill Sub Category",
  //   inputType: EFormFieldInputTypes.searchableSelect,
  // },
];

export const validateBatchRowFilter = (obj, filterForm) => {
  let flag = true;

  if (filterForm?.startDate && filterForm?.endDate) {
    flag = isBetween(
      YYYYMMDDFormat(obj.trainingDate),
      YYYYMMDDFormat(filterForm.startDate),
      YYYYMMDDFormat(filterForm.endDate)
    );
  }

  if (filterForm?.contractorId) {
    const contractorObj = obj?.traineeList?.find(
      (d) => +d.TrainingAssigneeData?.contractorId === filterForm?.contractorId
    );
    if (!contractorObj) flag = false;
  }

  if (flag) {
    for (const key in filterForm) {
      if (
        !filterForm[key] ||
        key === "contractorId" ||
        key === "startDate" ||
        key === "endDate"
      )
        continue;

      if (
        key !== "batchName" &&
        key !== "centerName" &&
        key !== "centerCode" &&
        obj[key] !== filterForm[key]
      )
        return (flag = false);
      else if (
        (key === "batchName" || key === "centerName" || key === "centerCode") &&
        !obj[key]?.toLowerCase()?.includes(filterForm[key]?.toLowerCase())
      )
        return (flag = false);
    }

    return (flag = true);
  }

  //if (flag) flag = validateRowFilter(filterForm, obj);
  return flag;
};

export const TM_STATUS = {
  due: "Due",
  overdue: "Over Due",
  soReview: "SO Review",
  completed: "Completed",
  scheduled: "Scheduled",
  mmReview: "MM Review",
  mmReview2: "MM Review ",
  approved: "Approved",
  due2: "Due (Absent)",
};

export const getTrainingManagementStatusClass = (status) => {
  switch (status) {
    case TM_STATUS.due:
      return "yellow text-white rounded text-center px-1";
    case TM_STATUS.due2:
      return "yellow text-white rounded text-center px-1";
    case TM_STATUS.overdue:
      return "red text-white rounded text-center px-1";
    case TM_STATUS.soReview:
      return "orange text-white rounded text-center px-1";
    case TM_STATUS.mmReview:
      return "orange text-white rounded text-center px-1";
    case TM_STATUS.mmReview2:
      return "orange text-white rounded text-center px-1";
    case TM_STATUS.scheduled:
      return "orange text-white rounded text-center px-1";
    case TM_STATUS.executed:
      return "green-300 text-white rounded text-center";
    case TM_STATUS.completed:
      return "success";
    case TM_STATUS.approved:
      return "success";
    default:
      return "success";
  }
};

export const allTrainingFilter = ["traineeTypeView", "traineeId", "siteId"];

export const trainerTypeList = [
  { id: "internal", label: "Internal" },
  { id: "external", label: "External" },
];

export const trainerTypeObj = {
  internal: "internal",
  external: "external",
};

export const trainerTypeView = {
  internal: "Internal",
  external: "External",
};
